import Vue from 'vue';
import 'arrive';

export default to => {
  if (to.meta && to.meta.autoScroll === false) {
    return null;
  }
  return new Promise(resolve => {
    if (to.params?.disableScrolling) {
      resolve({});
    }

    /* If the browser lost track of keyboard focus set it to the #main element */
    if (document.activeElement === document.body) {
      const main = document.getElementById('main');
      if (main) main.focus();
    }
    setTimeout(() => {
      const selector = `[id='${to.name}']`;
      let yOffset = -8;
      if (document.getElementById('navigation')) yOffset += document.getElementById('navigation').offsetHeight;
      if (document.getElementById('dashboard')) yOffset += document.getElementById('dashboard').offsetHeight;
      const offset = { x: 0, y: yOffset };

      if (document.tmr) clearTimeout(document.tmr);
      document.tmr = setTimeout(() => {
        document.unbindArrive();
      }, 5000);

      document.arrive(`#${to.name}`, { onceOnly: true, existing: true }, () => {
        clearTimeout(document.tmr);
        document.tmr = undefined;
        document.unbindArrive();
        // emitter.once('animationComplete', () => {});
        Vue.router.app.$root.$nextTick(() => {
          // TODO: vue3: will be replaced by import of nextTick
          if (!(to.meta && to.meta.scrollToId) && document.getElementById('breadcrumb')) {
            resolve({ selector: "[id='breadcrumb']", offset: { x: 0, y: yOffset + 12 } });
          } else {
            resolve({ selector, offset });
          }
        });
      });
    }, 250);
  });
};
